define('app/sdc/bootstrap/helper/sdc-bootstrap-helper-service',[], function () {
	function ColHelperProvider() {
		var provider = this;
		this.validMedia = ["xs", "sm", "md", "lg"];
		this.defaultMedia = "md";
		this.invalidMedia = null;
		this.invalidMedia_col = "col-xs-12";
		this.$get = function () {
			function bootstrapHelper(format, media, defaultMedia, invalidMedia) {
				defaultMedia = defaultMedia || provider.defaultMedia;
				invalidMedia = invalidMedia || provider.invalidMedia;
				media = media || defaultMedia;
				if (bootstrapHelper.isValidMedia(media)) {
					// Media is invalid;
					return angular.isFunction(invalidMedia) ? invalidMedia(media, format) : invalidMedia;
				}
				if (media) {
					return format.replace("#", media);
				}
				else {
					return "";
				}
			}

			bootstrapHelper.col = function col(width, media, defaultMedia, invalidMedia) {
				invalidMedia = invalidMedia || provider.invalidMedia_col;
				return bootstrapHelper(["col", "#", width].join("-"), media, defaultMedia, function (media) {
					return angular.isFunction(invalidMedia) ? invalidMedia(media, format) : invalidMedia;
				});
			}

			bootstrapHelper.isValidMedia = function (media) {
				return provider.validMedia.indexOf(media) < 0;
			}

			Object.defineProperties(bootstrapHelper, {
				validMedia: { get: function () { return provider.validMedia; } },
				defaultMedia: { get: function () { return provider.defaultMedia; } }
			});

			return bootstrapHelper;
		}
	}

	return new ColHelperProvider().$get();
});
